import PageMain from '../../components/Navigation/PageMain/PageMain';
import SmartReplyManagement from '../../components/Settings/Ai/SmartReply/SmartReplyManagement';

export default function AiSmartReplyPage() {
    return (
        <PageMain pageTitle="Smart Reply" showError={false} showLoading={false}>
            <div className="settingsPage">
                <div className="settingsPage__wrapper">
                    <SmartReplyManagement />
                </div>
            </div>
        </PageMain>
    );
}
